import React from "react";
import habits from "../assest/habits.png";
interface HabitspaceProps {
  title?: string;
  subtitle?: string;
  description?: string;
}

const Habitspace: React.FC<HabitspaceProps> = ({
  title = "Habit Space",
  subtitle = "Social habit tracking",
  description = "Crush your goals with a team cheering you on every step of the way. Create habits, track progress, and form groups that keep you accountable and motivated! because together, success is inevitable.",
}) => {

  return (
    <div className="flex items-center justify-center w-full bg-black text-white px-6 py-16 md:py-24 md:px-12 lg:px-20">
      <div className="relative max-w-6xl mx-auto w-full">
        <div className="relative flex flex-col md:flex-row items-center gap-8 bg-transparent rounded-lg">
          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="relative w-[80%] sm:w-[75%] md:w-[548px] h-auto">
              <img
                src={habits}
                alt="Team collaboration"
                className="w-full h-auto object-cover rounded-[32px]"
              />
            </div>
          </div>

          {/* Text Content Section */}
          <div className="w-full md:w-1/2 px-4 sm:px-8 md:px-6 flex flex-col justify-center text-center md:text-left">
            <h3 className="text-yellow-500 text-lg sm:text-xl font-semibold mb-2 font-robotoSerif">
              {subtitle}
            </h3>
            <h2 className="text-white text-3xl sm:text-4xl md:text-5xl font-bold font-inter leading-tight">
              {title}
            </h2>
            <p className="text-gray-300 text-base sm:text-lg font-dmSans mt-4">
              {description}
            </p>
            <div className="w-full max-w-md mx-auto md:mx-0 mt-6">
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                <a
                  href="https://apps.apple.com/us/app/habit-space/id6743495221"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-black border border-gray-600 hover:border-gray-400 rounded-lg px-4 py-2 transition-colors"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.evovance.habitspace"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-black border border-gray-600 hover:border-gray-400 rounded-lg px-4 py-2 transition-colors"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Habitspace;
